import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
export interface HttpEventOptions {
  headers?: HttpHeaders;
  params?: any;
  reportProgress?: boolean;
  observe?: 'events';
}
@Injectable({
  providedIn: 'root'
})

export class WhatsappTemplateService {

  constructor(private api: ApiService) { }

  getLeadsRocord(data:any): Observable<any> {
    return this.api.post(environment.getLeadsRocord,data);
  }

  getAllTemplate(data:any): Observable<any> {
    return this.api.post(environment.getAllWhatsappTemplates,data);
  }

    refreshGupshupTemplates(body: any): Observable<any> {
    return this.api.post(environment.refreshGupshupTemplates, body);
  }

  getAppId(data:any): Observable<any> {
    return this.api.post(environment.getAppId,data);
  }

  createTemplate(data:any): Observable<any> {
    return this.api.post(environment.createWhatsappTemplate,data);
  }

 uploadFile(file: File, clientId: any) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('client_id', clientId);
  formData.append('getWhatsappConfigURL', environment.getWhatsappConfig);

  return this.api.postEvent<any>(
    environment.uploadGupshupMedia,
    formData,
    {
      reportProgress: true,
      observe: 'events'
    } as HttpEventOptions
  );
}


  getAllLanguages(): Observable<any> {
    return this.api.post(environment.getAllLanguages,{});
  }

  updateTemplate(data:any): Observable<any> {
    return this.api.post(environment.updateWhatsappTemplate,data);
  }

  deleteTemplate(data:any): Observable<any> {
    return this.api.post(environment.deleteWhatsappTemplate,data);
  }
  
}


